import TimelineCircleImages from "../../../../timeline/TimelineCircleImages/TimelineCircleImages";

const ImageLeft = require('../../../../../assets/img/timeline/modal/2011-logo.jpg');
const ImageRight = require('../../../../../assets/img/timeline/modal/2011-old-logo.jpg');


const LogoContent = () => {
    return (
        <div style={{ overflow: "hidden", margin: "-16px", padding: "16px" }}>
            <TimelineCircleImages leftImage={ImageLeft} rightImage={ImageRight} leftClassName="vertical-timeline-image-color-1" rightClassName="vertical-timeline-image-color-2" />
            <h4 className="mb-0" style={{ position: "relative", zIndex: 2 }}>
                Our name and logo are updated to be the Australia and New Zealand Breast Cancer Trials Group (now Breast Cancer Trials).
            </h4>
        </div>
    );
}

export default LogoContent;